import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';
import { FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import About from '../components/About';
import { Helmet } from 'react-helmet';

const AboutPage = () => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <Helmet>
        <title>About - Vishwa Patel | Full Stack Developer</title>
        <meta name="description" content="Learn more about Vishwa Patel - Full Stack Developer with expertise in React, JavaScript, and modern web technologies" />
        <meta name="keywords" content="About Vishwa Patel, Full Stack Developer, Web Developer, React Developer, Portfolio" />
        <meta property="og:title" content="About Vishwa Patel" />
        <meta property="og:description" content="Discover the journey and skills of Vishwa Patel as a Full Stack Developer" />
      </Helmet>
    <div className={`min-h-screen ${isDarkMode ? 'bg-dark-bg' : 'bg-light-bg'}`}>
      <div className="pt-20">
        {/* Back to Home Button */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
          <motion.button
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate('/home')}
            className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-all duration-300 ${
              isDarkMode
                ? 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            <FaHome className="w-4 h-4" />
            <span>Back to Home</span>
          </motion.button>
        </div>

        {/* About Content */}
        <About />

      </div>
    </div>
    </>
  );
};

export default AboutPage;
